<template>
	<div class="app-user user-alerts">
		<div class="header">
			<h1>{{ $t('base.general.alerts') }}</h1>
			<div class="btn-group">
				<button-native-icon-text icon="check" class="btn-add" @click.native="onButtonClearAlerts">{{ $t('buttons.actions.clear_alerts') }}</button-native-icon-text>
			</div>
		</div>
		<div class="body">
			<spinner v-if="alerts.loading"/>
			<p v-if="!alerts.loading && !alerts.data.length">{{ $t('base.general.no_alerts') }}</p>
			<div class="today" v-if="today.length">
				<div class="section">{{ $t('labels.general.today') }}</div>
				<div class="alerts">
					<alert v-for="alert in today" :key="alert.id" :alert="alert"/>
				</div>
			</div>
			<div class="previous" v-if="previous.length">
				<div class="section">{{ $t('labels.general.previous') }}</div>
				<div class="alerts">
					<alert v-for="alert in previous" :key="alert.id" :alert="alert"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
import ApiCollection from '@/classes/api/ApiCollection'
import Alert from './alerts/Alert'
export default {
	components: {
		Alert
	},
	props: [
		'user_uid'
	],
	data () {
		return {
			alerts: new ApiCollection(),
			patients: new ApiCollection()
		}
	},
	computed: {
		selectedAccount () {
			return this.$store.state.user.selectedAccount
		},
		today () {
			const today = this.$moment().format('YYYY-MM-DD')
			return this.alerts.data.filter(element => this.$moment(element.create_time).format('YYYY-MM-DD') === today)
		},
		previous () {
			const today = this.$moment().format('YYYY-MM-DD')
			return this.alerts.data.filter(element => !(this.$moment(element.create_time).format('YYYY-MM-DD') === today))
		}
	},
	methods: {
		getAlertsPromise () {
			return this.$api.warnings.getAll(this, this.selectedAccount)
				.then(response => {
					this.$log.info('alerts', 'warnings.getAll OK', response)()
					return response.body.filter(alert => alert.type === 1 || alert.type === 7)
				})
		},
		getPatientsPromise () {
			return this.$api.patients.getAll(this, this.selectedAccount)
				.then(response => {
					this.$log.info('patients', 'patients.getAll OK', response)()
					return response.body.sort((a, b) => a.name.localeCompare(b.name))
				})
		},
		getProfile (patient) {
			this.$set(patient, 'profile', new ApiObject())
			patient.profile.loading = true
			this.$api.profile.get(this, this.selectedAccount, patient.id)
				.then(response => {
					this.$log.info('patient profile', 'profile.get OK', response)()
					patient.profile.data = response.body
				})
				.catch(error => {
					this.$log.error('patient profile', 'profile.get ERROR', error)()
					patient.profile.error = error
				})
				.finally(() => {
					patient.profile.loading = false
				})
		},
		getReading (alert) {
			this.$set(alert, 'reading', new ApiObject())
			const user_uid = alert.args.user
			const watch_id = alert.args.virtual_watch
			const type_id = alert.args.type
			const reading_id = alert.args.reading.id
			alert.reading.loading = true
			this.$api.readings.getByID(this, user_uid, watch_id, type_id, reading_id)
				.then(response => {
					this.$log.info('alert reading', 'readings.getByID OK', response)()
					alert.reading.data = response.body
				})
				.catch(error => {
					this.$log.error('alert reading', 'readings.getByID ERROR', error)()
					alert.reading.error = error
				})
				.finally(() => {
					alert.reading.loading = false
				})
		},
		getAlertsAndPatients () {
			this.alerts.loading = true
			this.patients.loading = true
			Promise.all([ this.getAlertsPromise(), this.getPatientsPromise() ])
				.then(([ alerts, patients ]) => {
					this.$log.info('dashboard', 'getAlertsAndPatients() OK', [ alerts, patients ])()
					// add profile to watches
					this.patients.data = patients
					this.patients.data.forEach(patient => {
						this.getProfile(patient)
					})
					// add reading and watch/profile to alerts
					this.alerts.data = alerts
					this.alerts.data.forEach(alert => {
						if (alert.type !== 7) {
							this.getReading(alert)
						}
						this.patients.data.forEach(patient => {
							if (patient.id == alert.args.virtual_watch) {
								this.$set(alert, 'patient', new ApiObject())
								alert.patient = patient
							}
						})
					})
				})
				.catch(error => {
					this.$log.error('dashboard', 'getAlertsAndPatients() ERROR', error)()
				})
				.finally(() => {
					this.alerts.loading = false
					this.patients.loading = false
				})
		},
		updateAlert (id) {
			const user_uid = this.user_uid
			const model = { id, reading_time: this.$moment().format() }
			return this.$api.warnings.update(this, user_uid, model)
				.then(response => {
					this.$log.info('alerts', 'alert.update OK', response)()
					this.$store.dispatch('getAccountAlerts', { context: this, user_uid: user_uid })
				})
				.catch(error => {
					this.$log.error('alerts', 'alert.update ERROR', error)()
				})
		},
		onButtonClearAlerts () {
			if (confirm(this.$t('buttons.actions.clear_alerts') + '?')) {
				let uncheckedAlerts = []
				let promises = []
				this.alerts.data.forEach(alert => {
					if (!this.isChecked(alert)) {
						uncheckedAlerts.push(alert)
						promises.push(this.updateAlert(alert.id))
					}
				})
				Promise.all(promises)
					.then(response => {
						this.$log.info('alerts', 'all alert.update OK', response)()
						this.getAlertsAndPatients()
					})
					.catch(error => {
						this.$log.error('alerts', 'all alert.update ERROR', error)()
					})
			}
		},
		isChecked (alert) {
			return !!alert.reading_time
		}
	},
	beforeCreate () {
		this.$title('Alerts')
	},
	mounted () {
		this.getAlertsAndPatients()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/UserAlerts.vue